import { ObjectLoader } from 'three';
export class ViewerCommand {
    constructor(viewer, objects) {
        this.updatable = false;
        this.inMemory = false;
        this.viewer = viewer;
        this.objects = objects;
    }
    toJSON() {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            objects: this.objects.map(object => object.toJSON()),
        };
    }
    fromJSON(json) {
        this.inMemory = true;
        this.id = json.id;
        this.type = json.type;
        this.name = json.name;
        const loader = new ObjectLoader();
        this.objects = json.objects.map((objectJson) => {
            let object = this.viewer.getObjectByUUID(objectJson.object.uuid);
            if (!object) {
                object = loader.parse(object);
            }
            return object;
        });
    }
    isCompatibleWith(cmd) {
        const areObjectArraysEqual = this.objects.length === cmd.objects.length &&
            this.objects.every((obj, index) => obj.uuid === cmd.objects[index].uuid);
        return this.type === cmd.type && areObjectArraysEqual;
    }
    composeName() {
        return `${this.type}: ${this.objects.map((object) => object.uuid).join(' ')}`;
    }
}
